import React from 'react';
import WorkEdit from '../pages/WorkEdit';

export const WorkHourModal = ({
  onUpdate,
  onClose,
  workId,
  scheduleFlag,
  fieldInfo = null,
  workData = null,
  isWorkBatchEdit = false,
  unapprovedFlag,
}) => {
  const handleUpdate = data => {
    onUpdate(data);
    onClose();
  };

  return (
    <WorkEdit
      isWorkSchedule={scheduleFlag}
      isWorkHourModal={true}
      view={{ state: { id: workId } }}
      onClose={onClose}
      onUpdate={handleUpdate}
      fieldInfo={fieldInfo}
      workData={workData}
      isWorkBatchEdit={isWorkBatchEdit}
      unapprovedFlag={unapprovedFlag}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/WorkHourModal.jsx